import React from 'react';
import {Typography} from '@mui/material';
import {PuiButton, PuiDialog, PuiGrid} from "@portnet/ui";
import InfoIcon from '@mui/icons-material/Info'; // Importing the Info icon


const DialogInformation = ({ open, close, text, confirmation, confirmOk,showTitleIcon  }) => {
    const titleElement = (
        <PuiGrid container alignItems="center" spacing={1}>
            {showTitleIcon && (
            <PuiGrid item>
                <InfoIcon />
            </PuiGrid>
            )}
            <PuiGrid item>
                <Typography variant="h6">Information</Typography>
            </PuiGrid>
        </PuiGrid>
    );

    return (
        <PuiDialog
            onClose={close}
            open={open}
            maxWidth="sm"
            fullWidth
            title={titleElement}
        >
            <PuiGrid container justifyContent="center">
                <PuiGrid item>
                    <Typography>{text}</Typography>
                </PuiGrid>
            </PuiGrid>
            {confirmation && (
                <>
                    <PuiGrid container justifyContent="flex-end" marginTop={2}>
                        <PuiGrid item>
                            <PuiButton color="tertiary" onClick={close}>
                                Non
                            </PuiButton>
                        </PuiGrid>
                        {confirmOk && (
                            <PuiGrid item>
                                <PuiButton onClick={confirmOk}>Oui</PuiButton>
                            </PuiGrid>
                        )}
                    </PuiGrid>
                </>
            )}
        </PuiDialog>
    );
}

export default DialogInformation;
